import React,
{
  useCallback, useEffect,
  useMemo, useRef,
  useState
} from 'react';
import SplitterLayout from 'react-splitter-layout';
import { Button } from 'devextreme-react/button';
import { Column, ColumnFixing } from 'devextreme-react/data-grid';
import { SelectBox, TextArea, TextBox } from 'devextreme-react';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { formatMessage } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import FileUploader from 'devextreme-react/file-uploader';
import DataGridMVP from '../DataGridMVP';
import HeaderButtonMVP from '../HeaderButtonMVP';
import PopupMVP from '../PopupMVP';
import style from '../ResponsiblePerson/UserAdmin/useradmin.module.scss';
// eslint-disable-next-line import/named
import { themeDark, trim } from '../../utils/functions';
import columnDataChapters from './columnDataChapters';
import columnDataManuals from './columnDataManuals';

const initDataChapter = {
  chapterNumId: null,
  chapterTitle: null,
  modalTitle: null,
  plantId: null,
  shippingType: null
};

const initDataManual = {
  chapterNumId: null,
  fileName: null,
  manualDescr: null,
  manualNumId: null,
  manualTitle: null,
  modalMode: null,
  modalTitle: null
};

const initFocusChapterModalItems = {
  chapterTitle: null,
  shippingType: null
};

const initFocusManualModalItems = {
  manualDescr: null,
  manualTitle: null
};

const listShippingTypes = [
  {
    id: 0,
    name: 'Экспедиторы'
  },
  {
    id: 1,
    name: 'Консигнаторы'
  },
  {
    id: 2,
    name: 'Переработчики'
  }
];

const UserManualTab = ({
  userManualReducer: {
    chapters,
    chaptersManualsList,
    manuals
  },
  userReducer: {
    id
  },
  addOrEditChapter,
  addOrEditManual,
  chaptersInit,
  deleteChapter,
  deleteManual,
  getListChapters,
  modalErrorOpen,
  moveChapter,
  moveManual,
  plantId,
  tabSelect,
  videoViewerOpen
}) => {
  const [selectedRowDataChapter, setSelectedRowDataChapter] = useState(null);
  const [visibleModalAddOrEditManual, setVisibleModalAddOrEditManual] = useState(false);
  const [dataChapter, setDataChapter] = useState(initDataChapter);
  const [dataManual, setDataManual] = useState(initDataManual);
  // eslint-disable-next-line max-len
  const [isFocusChapterModalItems, setIsFocusChapterModalItems] = useState(initFocusChapterModalItems);
  const [isFocusManualModalItems, setIsFocusManualModalItems] = useState(initFocusManualModalItems);
  const [isChapterModalValid, setIsChapterModalValid] = useState(1);
  const [isManualModalValid, setIsManualModalValid] = useState(1);
  const [listChapters, setListChapters] = useState([]);
  const [listManuals, setListManuals] = useState([]);
  const [chapterDataGridInstance, setChapterDataGridInstance] = useState({});
  const [manualDataGridInstance, setManualDataGridInstance] = useState({});
  const [visibleModalAddOrEditChapter, setVisibleModalAddOrEditChapter] = useState(false);
  const fileUp = useRef(null);

  useEffect(() => {
    if (id !== null) {
      getListChapters({ plantId });
    }
  }, [
    getListChapters,
    id,
    plantId,
    tabSelect
  ]);

  useEffect(() => {
    if (chapters.getRequest) {
      setListChapters(
        chaptersManualsList.map((item, index, arr) => ({
          chapterNumId: item.manualChapterNumId,
          chapterTitle: item.title,
          shippingType: item.shippingType,
          orderIndex: index + 1,
          maxIndex: arr.length
        }))
      );
      chaptersInit();
      if (selectedRowDataChapter) {
        setListManuals(
          chaptersManualsList
            .filter((item) => item.manualChapterNumId === selectedRowDataChapter)[0]
            .manualDtoList.map((item, index, arr) => ({
              fileName: item.attachmentDto.originalFileName,
              manualNumId: item.manualNumId,
              manualTitle: item.title,
              orderIndex: index + 1,
              maxIndex: arr.length
            }))
        );
      }
    }
  }, [chapters.getRequest, chaptersInit, chaptersManualsList, selectedRowDataChapter]);

  useEffect(() => {
    if (chapters.editRequest) {
      notify(
        {
          message: formatMessage('dataSuccess'),
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'success',
        2000
      );
      chapterDataGridInstance.instance.clearSelection();
      manualDataGridInstance.instance.clearSelection();
      setSelectedRowDataChapter(null);
      setVisibleModalAddOrEditChapter(false);
      chaptersInit();
    }
  }, [
    chaptersInit,
    chapters.editRequest,
    chapterDataGridInstance.instance,
    manualDataGridInstance.instance
  ]);

  const openModalAddOrEditChapter = useCallback((data = initDataChapter) => {
    setDataChapter({
      ...data,
      chapterTitle: data.chapterNumId ? data.chapterTitle : '',
      modalTitle: data.chapterNumId ? 'Редактирование раздела' : 'Добавить раздел',
      plantId,
      shippingType: data.chapterNumId ? data.shippingType : null
    });
    setVisibleModalAddOrEditChapter(true);
  }, [plantId]);

  const onHidingModalAddOrEditChapter = useCallback(() => {
    setDataChapter(initDataChapter);
    setVisibleModalAddOrEditChapter(false);
  }, []);

  const sendSaveAddOrEditChapter = useCallback(() => {
    setIsFocusChapterModalItems(initFocusChapterModalItems);
    setIsChapterModalValid(1);
    if (trim(dataChapter.chapterTitle, ' ') === ''
      || trim(dataChapter.shippingType, ' ') === '') {
      setIsChapterModalValid(0);
    } else {
      addOrEditChapter(dataChapter);
    }
  }, [addOrEditChapter, dataChapter]);

  const openModalAddOrEditManual = useCallback((data = initDataManual) => {
    setDataManual((prevState) => ({
      ...prevState,
      chapterNumId: selectedRowDataChapter,
      manualTitle: data.manualNumId ? data.manualTitle : '',
      manualDescr: data.manualNumId ? data.manualDescr : '',
      modalMode: data.manualNumId ? 'edit' : 'add',
      modalTitle: data.manualNumId ? 'Редактирование инструкции' : 'Добавить инструкцию',
      plantId
    }));
    setVisibleModalAddOrEditManual(true);
  }, [plantId, selectedRowDataChapter]);

  const onHidingModalAddOrEditManual = useCallback(() => {
    fileUp.current.instance.reset();
    setDataManual(initDataManual);
    setVisibleModalAddOrEditManual(false);
  }, []);

  const sendSaveAddOrEditManual = useCallback(() => {
    setIsFocusManualModalItems(initFocusManualModalItems);
    setIsManualModalValid(1);
    if (trim(dataManual.manualTitle, ' ') === ''
      || trim(dataManual.manualDescr, ' ') === ''
      || !(fileUp.current.instance && fileUp.current.instance._files[0])
    ) {
      setIsManualModalValid(0);
      if (!(fileUp.current.instance && fileUp.current.instance._files[0])) {
        modalErrorOpen({
          message: `${formatMessage('textError').addFile}`,
          techInfo: '',
          types: 'info',
          title: formatMessage('textError').warning
        });
      }
    } else {
      addOrEditManual({
        chapterNumId: dataManual.chapterNumId,
        isActiveFlag: 1,
        file: fileUp.current.instance._files[0].value,
        manualDescr: dataManual.manualDescr,
        manualNumId: dataManual.manualNumId,
        manualTitle: dataManual.manualTitle,
        modalTitle: dataManual.modalTitle,
        plantId
      });
      onHidingModalAddOrEditManual();
    }
  }, [addOrEditManual, dataManual, modalErrorOpen, onHidingModalAddOrEditManual, plantId]);

  const openModalVideoViewer = useCallback((manualNumId) => {
    const manualsList = [];
    chaptersManualsList.forEach((itemChapter) => {
      manualsList.push({
        itemNumId: 1000000 + itemChapter.manualChapterNumId,
        manualNumId: null,
        parentItemNumId: null,
        description: itemChapter.title,
        fileName: null,
        filePath: null
      });
      itemChapter.manualDtoList.forEach((itemManual) => {
        manualsList.push({
          itemNumId: itemManual.manualNumId,
          manualNumId: itemManual.manualNumId,
          parentItemNumId: 1000000 + itemChapter.manualChapterNumId,
          description: itemManual.title,
          fileName: itemManual.attachmentDto.originalFileName,
          filePath: itemManual.attachmentDto.storedFileUrl
        });
      });
    });
    videoViewerOpen({
      chaptersManualsList,
      manualsList,
      manualChapterNumId: dataManual.chapterNumId,
      // eslint-disable-next-line react/destructuring-assignment
      manualNumId
    });
  }, [chaptersManualsList, dataManual.chapterNumId, videoViewerOpen]);

  const renderButtonMove = useMemo(() => (data, direction) => (
    <Button type="default"
            stylingMode="text"
            icon={direction === 'up'
              ? themeDark() ? '/images/chevronup_dark.svg' : '/images/chevronup.svg'
              : themeDark() ? '/images/chevrondown_dark.svg' : '/images/chevrondown.svg'}
      /* eslint-disable-next-line react/destructuring-assignment */
            onClick={() => data.data.chapterNumId
              ? moveChapter({
              /* eslint-disable-next-line react/destructuring-assignment */
                chapterNumId: data.data.chapterNumId,
                plantId,
                sortOrder: direction
              })
              : moveManual({
                /* eslint-disable-next-line react/destructuring-assignment */
                manualNumId: data.data.manualNumId,
                plantId,
                sortOrder: direction
              })}
      /* eslint-disable-next-line react/destructuring-assignment */
            disabled={(direction === 'up' && data.data.orderIndex === 1)
              /* eslint-disable-next-line react/destructuring-assignment */
              || (direction === 'down' && data.data.orderIndex === data.data.maxIndex)}
    />
  ), [moveChapter, moveManual, plantId]);

  const renderButtonAddOrEdit = useMemo(() => (data) => (
    <Button type="default"
            stylingMode="text"
            icon="edit"
            onClick={() => {
              // eslint-disable-next-line react/destructuring-assignment,no-unused-expressions
              data.data.chapterNumId
                // eslint-disable-next-line react/destructuring-assignment
                ? openModalAddOrEditChapter(data.data)
                // eslint-disable-next-line react/destructuring-assignment
                : openModalAddOrEditManual(data.data);
            }}
    />
  ), [openModalAddOrEditChapter, openModalAddOrEditManual]);

  const renderButtonDelete = useMemo(() => (data) => (
    <Button type="default"
            stylingMode="text"
            icon="trash"
            onClick={() => {
              // eslint-disable-next-line react/destructuring-assignment,no-unused-expressions
              data.data.chapterNumId
                ? deleteChapter({
                // eslint-disable-next-line react/destructuring-assignment
                  chapterNumId: data.data.chapterNumId,
                  plantId
                })
                : deleteManual({
                // eslint-disable-next-line react/destructuring-assignment
                  manualNumId: data.data.manualNumId,
                  plantId
                });
            }}
    />
  ), [deleteChapter, deleteManual, plantId]);

  const renderButtonPlay = useMemo(() => (data) => (
    <Button type="default"
            stylingMode="text"
            icon={themeDark() ? '/images/play-video_dark.svg' : '/images/play-video.svg'}
            onClick={() =>
              // eslint-disable-next-line react/destructuring-assignment
              openModalVideoViewer(data.data.manualNumId)}
      />
  ), [openModalVideoViewer]);

  const onSelectChapter = useCallback(({ selectedRowsData }) => {
    if (selectedRowsData && selectedRowsData.length) {
      setSelectedRowDataChapter(selectedRowsData[0].chapterNumId);
      setDataManual((item) => ({
        ...item,
        chapterNumId: selectedRowsData[0].chapterNumId
      }));
      setListManuals(
        chaptersManualsList
          .filter((item) => item.manualChapterNumId === selectedRowsData[0].chapterNumId)[0]
          .manualDtoList.map((item, index, arr) => ({
            fileName: item.attachmentDto.originalFileName,
            manualNumId: item.manualNumId,
            manualTitle: item.title,
            orderIndex: index + 1,
            maxIndex: arr.length
          }))
      );
    }
  }, [chaptersManualsList]);

  const renderColumnsDataGridChapter = useMemo(() => (
    columnDataChapters.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={item.caption}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderChapterList = useMemo(() => (
    <>
      <HeaderButtonMVP headButtVisibol={{ display: 'flex', width: '50%' }}>
        <Button text={formatMessage('textButton').createChapter}
                type="default"
                stylingMode="contained"
                onClick={() => openModalAddOrEditChapter()}
        />
      </HeaderButtonMVP>
      <DataGridMVP className="shipment"
                   dataSource={listChapters}
                   keyExpr="chapterNumId"
                   loadingData={chapters.getting}
                   onSelectionChanged={onSelectChapter}
                   selectionMode="single"
                   setDataGridInstance={setChapterDataGridInstance}
                   visibleButtonDateRangePicker={false}
                   visibleFilter={false}
                   visibleFilterPanel={false}
                   visibleGroupPanel={false}
                   visibleHeaderFilter={false}
                   visibleInfoIcon={false}
                   visibleSearchPanel={false}
                   visibleSummary={false}
      >
        <ColumnFixing enabled />
        { renderColumnsDataGridChapter }
        <Column cellRender={(value) => renderButtonMove(value, 'up')}
                width={50}
                fixed
                fixedPosition="right"
        />
        <Column cellRender={(value) => renderButtonMove(value, 'down')}
                width={50}
                fixed
                fixedPosition="right"
        />
        <Column cellRender={renderButtonAddOrEdit}
                width={50}
                fixed
                fixedPosition="right"
        />
        <Column cellRender={renderButtonDelete}
                width={50}
                fixed
                fixedPosition="right"
        />
      </DataGridMVP>
    </>
  ), [
    chapters.getting,
    listChapters,
    onSelectChapter,
    openModalAddOrEditChapter,
    renderButtonAddOrEdit,
    renderButtonDelete,
    renderButtonMove,
    renderColumnsDataGridChapter
  ]);

  const renderColumnsDataGridManual = useMemo(() => (
    columnDataManuals.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={item.caption}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderUserManualList = useMemo(() => (
    <>
      <HeaderButtonMVP headButtVisibol={{ display: 'flex', width: '50%' }}>
        <Button text={formatMessage('textButton').createManual}
                type="default"
                stylingMode="contained"
                onClick={() => openModalAddOrEditManual()}
                disabled={!selectedRowDataChapter}
        />
      </HeaderButtonMVP>
      <DataGridMVP className="shipment"
                   dataSource={listManuals}
                   filterDataGrid
                   keyExpr="manualNumId"
                   loadingData={chapters.getting}
                   selectionMode="single"
                   setDataGridInstance={setManualDataGridInstance}
                   visibleButtonDateRangePicker={false}
                   visibleFilter={false}
                   visibleFilterPanel={false}
                   visibleGroupPanel={false}
                   visibleHeaderFilter={false}
                   visibleInfoIcon={false}
                   visibleSearchPanel={false}
                   visibleSummary={false}
      >
        <ColumnFixing enabled />
        { renderColumnsDataGridManual }
        <Column cellRender={(value) => renderButtonPlay(value)}
                width={50}
                fixed
                fixedPosition="right"
        />
        <Column cellRender={(value) => renderButtonMove(value, 'up')}
                width={50}
                fixed
                fixedPosition="right"
        />
        <Column cellRender={(value) => renderButtonMove(value, 'down')}
                width={50}
                fixed
                fixedPosition="right"
        />
        <Column cellRender={renderButtonAddOrEdit}
                width={50}
                fixed
                fixedPosition="right"
        />
        <Column cellRender={renderButtonDelete}
                width={50}
                fixed
                fixedPosition="right"
        />
      </DataGridMVP>
    </>
  ), [
    selectedRowDataChapter,
    listManuals,
    chapters.getting,
    renderColumnsDataGridManual,
    renderButtonAddOrEdit,
    renderButtonDelete,
    renderButtonPlay,
    openModalAddOrEditManual,
    renderButtonMove
  ]);

  const renderModalAddOrEditChapter = useMemo(() => (
    <PopupMVP visible={visibleModalAddOrEditChapter}
              onHiding={onHidingModalAddOrEditChapter}
              title={dataChapter.modalTitle}
    >
      <div className="formData">
        <div className="optionsRow">
          <div className="optionsData">
            <span>{formatMessage('textModal').nameChapter}</span>
            <TextBox stylingMode="outlined"
                     placeholder="Введите название раздела"
                     value={dataChapter.chapterTitle}
                     onValueChanged={({ value }) => {
                       setDataChapter((item) => ({
                         ...item,
                         chapterTitle: value
                       }));
                     }}
                     onFocusIn={() => setIsFocusChapterModalItems({
                       chapterTitle: true,
                       shippingType: false
                     })}
                     isValid={isFocusChapterModalItems.chapterTitle
                       || (trim(dataChapter.chapterTitle, ' ') !== '')
                       || !!isChapterModalValid}
                     validationError={{ message: formatMessage('textError').fieldNotFilled }}
            />
          </div>
        </div>
        <div className="optionsRow">
          <div className="optionsData">
            <span>{formatMessage('textModal').textMessageShippingType}</span>
            <SelectBox items={listShippingTypes}
                       displayExpr="name"
                       valueExpr="id"
                       stylingMode="outlined"
                       value={dataChapter.shippingType}
                       onValueChanged={
                         ({ value }) => setDataChapter((item) => ({
                           ...item,
                           shippingType: value
                         }))
                       }
                       onFocusIn={() => setIsFocusChapterModalItems({
                         chapterTitle: false,
                         shippingType: true
                       })}
                       isValid={isFocusChapterModalItems.shippingType
                         || (trim(dataChapter.shippingType, ' ') !== '')
                         || !!isChapterModalValid}
                       validationError={{ message: formatMessage('textError').noValueSelected }}
            />
          </div>
        </div>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModalAddOrEditChapter}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={sendSaveAddOrEditChapter}
                  width={200}
          >
            <LoadIndicator className="indicator" visible={chapters.getting} />
            <span>Сохранить</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    visibleModalAddOrEditChapter,
    onHidingModalAddOrEditChapter,
    dataChapter.modalTitle,
    dataChapter.chapterTitle,
    dataChapter.shippingType,
    isFocusChapterModalItems.chapterTitle,
    isFocusChapterModalItems.shippingType,
    isChapterModalValid,
    sendSaveAddOrEditChapter,
    chapters.getting
  ]);

  const renderModalAddOrEditManual = useMemo(() => (
    <PopupMVP visible={visibleModalAddOrEditManual}
              onHiding={onHidingModalAddOrEditManual}
              title={dataManual.modalTitle}
              height="510"
    >
      <div className="formData">
        <div className="optionsRow">
          <div className="optionsData">
            <span>{formatMessage('textModal').nameManual}</span>
            <TextBox stylingMode="outlined"
                     placeholder="Введите название инструкции"
                     value={dataManual.manualTitle}
                     onValueChanged={({ value }) =>
                       setDataManual((item) => ({
                         ...item,
                         manualTitle: value
                       }))}
                     onFocusIn={() => setIsFocusManualModalItems({
                       manualDescr: false,
                       manualTitle: true
                     })}
                     isValid={isFocusManualModalItems.manualTitle
                       || (trim(dataManual.manualTitle, ' ') !== '')
                       || !!isManualModalValid}
                     validationError={{ message: formatMessage('textError').fieldNotFilled }}
            />
          </div>
        </div>
        <div className="optionsRow">
          <div className="optionsData">
            <span>{formatMessage('textModal').description}</span>
            <TextArea height={80}
                      value={dataManual.manualDescr}
                      onValueChanged={({ value }) =>
                        setDataManual((item) => ({
                          ...item,
                          manualDescr: value
                        }))}
                      stylingMode="outlined"
                      onFocusIn={() => setIsFocusManualModalItems({
                        manualDescr: true,
                        manualTitle: false
                      })}
                      isValid={isFocusManualModalItems.manualDescr
                        || (trim(dataManual.manualDescr, ' ') !== '')
                        || !!isManualModalValid}
                      validationError={{ message: formatMessage('textError').enterDescription }}
            />
          </div>
        </div>
        <div className="optionsRow bottomRow">
          { dataManual.mode === 'edit' && (
          <div className="optionsData">
            <span>{formatMessage('textModal').attachedFile}</span>
            <span>{dataManual.fileName}</span>
          </div>
          )}
          <div className="optionsData fileUploader">
            {/* <span>файл для загрузки:</span> */}
            <FileUploader selectButtonText="Выберите файл для загрузки"
                          labelText=""
                          accept="video/mp4"
                          allowedFileExtensions={['.mp4']}
                          uploadMode="useForm"
                          ref={fileUp}
            />
          </div>
        </div>
        <div className="formButton">
          <Button text="Отмена"
                  type="default"
                  stylingMode="text"
                  onClick={onHidingModalAddOrEditManual}
          />
          <Button type="default"
                  stylingMode="contained"
                  onClick={sendSaveAddOrEditManual}
                  width={200}
          >
            <LoadIndicator className="indicator" visible={chapters.getting} />
            <span>Сохранить</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    visibleModalAddOrEditManual,
    onHidingModalAddOrEditManual,
    dataManual.fileName,
    dataManual.modalTitle,
    dataManual.manualTitle,
    dataManual.manualDescr,
    dataManual.mode,
    isFocusManualModalItems.manualTitle,
    isFocusManualModalItems.manualDescr,
    isManualModalValid,
    sendSaveAddOrEditManual,
    chapters.getting
  ]);

  return (
    <div className={style.containing}>
      <SplitterLayout>
        <div>
          <p><b>разделы</b></p>
          {renderChapterList}
        </div>
        <div>
          <p><b>Инструкции пользователя</b></p>
          {renderUserManualList}
        </div>
      </SplitterLayout>
      {renderModalAddOrEditChapter}
      {renderModalAddOrEditManual}
    </div>
  );
};

export default UserManualTab;
